export const workdeskFilterConstants = {
  TOGGLE_SELECTED_INBOX: 'TOGGLE_SELECTED_INBOX',
  TOGGLE_SELECTED_STATUS: 'TOGGLE_SELECTED_STATUS',
  TOGGLE_SELECTED_STATUS_ALL: 'TOGGLE_SELECTED_STATUS_ALL',
  SELECT_STATUS_TYPE: 'WORKDESK_SELECT_STATUS_TYPE',
  SET_SELECTED_INBOXES: 'SET_SELECTED_INBOXES',
  TOGGLE_SORT_BY_OF_FIELD: 'TOGGLE_SORT_BY_OF_FIELD',
  CHANGE_START_AT_FOR_STATUS: 'CHANGE_START_AT_FOR_STATUS',
  HAD_WORKDESK_FILTER_IN_LS_ON_INIT:
    'HAD_WORKDESK_FILTER_IN_LS_ON_INIT',
  SET_SEARCH_VALUES: 'WORKDESK_SET_SEARCH_VALUES',
  SET_HAD_CALLED_API: 'SET_HAD_CALLED_API',
  CACHE_BEFORE_LOAD_SELECTED_INBOXES:
    'CACHE_BEFORE_LOAD_SELECTED_INBOXES',
  RESTORE_FROM_BEFORE_LOAD_SELECTED_INBOXES:
    'RESTORE_FROM_BEFORE_LOAD_SELECTED_INBOXES',
};
